export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4852.3548e6f1.jpg";